<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-10-04 15:44:01
 * @LastEditTime: 2019-10-07 16:52:44
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div v-if="infoVideoOptions">
    <div class="video-container">
      <video-player
        class="video-show"
        :ref="`videoPlayer_${playerId}`"
        :options="playerOptions"
        :playsinline="true"
        @ended="onPlayerEnded($event)"
      ></video-player>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
require('video.js/dist/video-js.css')

export default {
  name: 'VideoDetail',
  components: {
    videoPlayer
  },
  props: {
    playerId: {
      type: [String, Number],
      default: 0
    },
    infoVideoOptions: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      player: '',
      playerOptions: {}
    }
  },
  watch: {
    // 切换swiper播放参数变化后重置播放
    infoVideoOptions(newPlayerOptions) {
      if (newPlayerOptions) {
        this.playerOptions.sources = [
          {
            src: newPlayerOptions.videoSrc
          }
        ]
        this.playerOptions.poster = newPlayerOptions.videoPoster
        // this.setPlayer()
      }
    }
  },
  mounted() {
    this.playerOptions = {
      muted: true,
      autoplay: false,
      width: document.body.clientWidth,
      language: 'zh-CN',
      controlBar: true,
      preload: 'none',
      sources: [
        {
          src: this.infoVideoOptions.videoSrc
        }
      ],
      poster: this.infoVideoOptions.videoPoster
    }
    // 设置player
    this.setPlayer()
  },
  created() {},
  methods: {
    /**
     * 自动播放
     */
    setPlayer() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.playVideo()
        }, 500)
      })
    },

    /**
     * 重新设置player
     */
    resetPlayer() {
      this.player = this.$refs['videoPlayer_' + this.playerId].player
    },

    /**
     * 视频结束时触发
     */
    onPlayerEnded(player) {
      try {
        if (player.isFullscreen()) {
          // 去除全屏
          player.exitFullscreen()
        }
      } catch (e) {}
    },

    /**
     * 播放视频
     */
    playVideo() {
      this.resetPlayer()
      this.player && this.player.play()
    },
    /**
     * 暂停视频
     */
    pauseVideo() {
      this.player && this.player.pause()
    }
  }
}
</script>
<style lang="scss" scoped src="./index.scss"></style>
